module.exports = __webpack_public_path__ + "img/intermittent_refrigeration.242bae77.png";